import { render, staticRenderFns } from "./settlement-detailed-list-store-wares.vue?vue&type=template&id=475e7991&scoped=true"
import script from "./settlement-detailed-list-store-wares.vue?vue&type=script&lang=js"
export * from "./settlement-detailed-list-store-wares.vue?vue&type=script&lang=js"
import style0 from "./settlement-detailed-list-store-wares.vue?vue&type=style&index=0&id=475e7991&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475e7991",
  null
  
)

export default component.exports